const AUTO_CALCULATED_QUESTION_IDS = {
  NPS: 4
};

export default AUTO_CALCULATED_QUESTION_IDS;
